import { forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type InternalProps = {
	onChange: (event: { target: { value: string } }) => void;
};

export const NumericInput = forwardRef<NumericFormatProps, InternalProps>((props, ref) => {
	const { onChange, ...rest } = props;

	return (
		<NumericFormat
			{...rest}
			decimalScale={2}
			getInputRef={ref}
			onValueChange={(values) =>
				onChange({
					target: {
						value: values.value,
					},
				})
			}
		/>
	);
});
